import React, { useEffect, useState } from "react";
import { FormWarning } from "../../../utils/context/FormWarningContext";
import './WarningMessages.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
interface WarningMessagesProps {
  showHeader?: boolean,
  warnings: FormWarning[],
  isWarningVisible?: (warning: FormWarning) => boolean,
  onWarningClick?: (warning: FormWarning) => void,
  customDisplay?: string | JSX.Element,
}
export default function WarningMessages(props: WarningMessagesProps) {
  const { t } = useTranslation(['common', 'transition']);
  const { i18n } = useTranslation();
  const { warnings } = props;
  const [hasScrolled, setHasScrolled] = useState(false)

  const visibleWarnings = warnings.filter(warning => {
    if (props.isWarningVisible) {
      return props.isWarningVisible(warning)
    }
    return true;
  });

  // Sort warning messages by question number using format "{Q#}. {warning message}"
  // if warning.message property has no Q# -> format "{warning message}", system will not affect order of returned warnings
  const sortWarnings = visibleWarnings.sort((a, b) => {
    if (a.message === null || !a.message.includes(".") || b.message === null || !b.message.includes(".")) {
      return 0;
    }

    if (Number(a.message.split(".")[0]) > Number(b.message.split(".")[0])) {
      return 1;
    } else if (Number(a.message.split(".")[0]) < Number(b.message.split(".")[0])) {
      return -1;
    } else {
      return 0;
    }
  })

  useEffect(() => {
    if (!hasScrolled && warnings.length > 0) {
      const element = document.getElementById('spectral-warning-container')
      element?.scrollIntoView({ behavior: 'smooth' })
      setHasScrolled(true)
    } else if (warnings.length === 0 && hasScrolled) {
      setHasScrolled(false)
    }
  }, [warnings, hasScrolled])

  return (<>
    {warnings.length > 0 &&
      <div className="warning-container" id='spectral-warning-container'>
        {
          props.customDisplay &&
          <p className="warning-heading">
            {props.customDisplay}
          </p>
        }
        {
          sortWarnings.length > 0 &&
          <>
            {
              (props.showHeader !== false) &&
              <p className="warning-heading">
                {
                  (sortWarnings.length !== warnings.length) &&
                  <>{sortWarnings.length} warnings on current page. </>
                }
                {t('warning-msg-header')}
              </p>
            }
            <ul className="warning-list">
              {sortWarnings.map((warning, idx) => (
                <li key={`${warning.primaryKey}-${idx}`}>
                  <FontAwesomeIcon icon={faCircleExclamation} className="warning-icon" />
                  <span onClick={() => {
                    if (props.onWarningClick) {
                      props.onWarningClick(warning)
                    }
                    const findByName = document.getElementsByName(warning.primaryKey)[0];
                    const findById = document.getElementById(warning.primaryKey);
                    const findByDataPrimaryKey = document.querySelector(`[data-primary-key="${warning.primaryKey}"]`)
                    if (findByName) {
                      findByName.scrollIntoView({ behavior: 'smooth' });
                    } else if (findById) {
                      findById.scrollIntoView({ behavior: 'smooth' })
                    } else if (findByDataPrimaryKey) {
                      findByDataPrimaryKey.scrollIntoView({ behavior: 'smooth' })
                    }
                  }}>{i18n.language === 'fr' ? warning.messageFr : warning.message}</span>
                </li>
              ))}
            </ul>
          </>
        }
      </div>
    }
  </>)
}